import React, { useRef } from 'react'
import { useSelector } from 'react-redux'

import { Dropdown } from 'components/common/Dropdown'
import Tooltip2 from 'components/common/Tooltip2.0'
import { ALL, MUTE } from 'constants/socket'
import useToggleHandler from 'hooks/useToggleHandler'
import { dispatchSendSocketMessage } from 'store/dispatcher'
import { _isTeacher } from 'store/selectors/User'
import { copyTextToClipboard } from 'utils/utils'

import AVTroubleshoot from './AVTroubleshoot'
import FullScreen from './FullScreen'
import { Container } from './styles'

const ICON_BASE = '/assets/revamp'

const studentMenuItems = [
    {
        icon: `${ICON_BASE}/url.svg`,
        alt: 'url',
        copy: 'Copy meet link',
        onClick: () => copyTextToClipboard(window.location.href),
    },
]

const teacherMenuItems = [
    {
        icon: `${ICON_BASE}/mute-all.svg`,
        alt: 'mute-all',
        copy: 'Mute all students',
        onClick: () => {
            dispatchSendSocketMessage({
                action: MUTE,
                user_id: ALL,
            })
        },
    },
    ...studentMenuItems,
]

const ThreeDotMenu = () => {
    const isTeacher = useSelector(_isTeacher)
    const menuItems = isTeacher ? teacherMenuItems : studentMenuItems

    const threeDotMenuRef = useRef()

    const { open: isOpen, toggle: toggleMenu } = useToggleHandler(
        threeDotMenuRef
    )

    return (
        <Tooltip2
            placement="bottom"
            className="hover-here"
            content={isOpen ? null : 'More options'}
        >
            <Container onClick={toggleMenu} ref={threeDotMenuRef}>
                <img src={`${ICON_BASE}/3DotMenu.svg`} alt="three-dot-menu" />
                {isOpen && (
                    <Dropdown menus={menuItems}>
                        <AVTroubleshoot />
                        <FullScreen />
                    </Dropdown>
                )}
            </Container>
        </Tooltip2>
    )
}

export default ThreeDotMenu
